// extracted by mini-css-extract-plugin
module.exports = {"container":"WidgetNotification_container__uhzsp","innerContainer":"WidgetNotification_innerContainer__2s446","message":"WidgetNotification_message__3ZMdh"};